<template>
    <div v-if="displayContextMenu" class="wrapper" @click.self="closeContextMenu">
        <ContextMenu
                :id="contextMenuInitiatorId"
                :position="contextMenuPosition"
                @close="closeContextMenu"
        ></ContextMenu>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import ContextMenu from "./ContextMenu";

    export default {
        name: "ContextMenuMain",

        components: {
            ContextMenu,
        },

        computed: {
            ...mapState('contextMenu', [
                'displayContextMenu',
                'contextMenuInitiatorId',
                'contextMenuPosition',
            ]),

        },

        methods: {
            ...mapActions('contextMenu', [
                'closeContextMenu',
            ]),

        },

    }
</script>

<style scoped>
    .wrapper {
        position: absolute;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>